export const environment = {
  production: false
};

// export const URL_WEB    = 'https://homolog-api.madelife.med.br/api/web';
// export const URL_GLOBAL = 'https://homolog-api.madelife.med.br/api';

// export const URL_WS_CHAMADO = 'wss://homolog-api.madelife.med.br.com:1122';
// export const URL_WS_CHATGERAL = 'wss://homolog-api.madelife.med.br.com:1123';
export const URL_WEB = 'https://api.madelife.med.br/api/web';
export const URL_GLOBAL = 'https://api.madelife.med.br/api';

export const URL_WS_CHAMADO = 'wss://api.madelife.med.br:1122';
export const URL_WS_CHATGERAL = 'wss://api.madelife.med.br:1123';
